import axios from 'axios'
import qs from 'qs'
import { startsWith } from '@/libs/lodash'

const BASE_URL = process.env.REACT_APP_BASE_URL

axios.interceptors.request.use(
  (config: any) => {
    return {
      ...config,
      baseURL: BASE_URL,
      withCredentials: true,
      paramsSerializer: (params: object) => {
        return qs.stringify(params, { encode: false })
      },
      headers: { 'Content-Type': 'application/json', ...config.headers },
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)
axios.interceptors.request.use(
  async (config) => {
    if (startsWith(config.url, 'api/auth')) {
      await axios.get('sanctum/csrf-cookie')
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)
